import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SelectedSkill {
  skillId?: string;

  skillTag?: string;

  proficiency?: string;

  verified?: boolean;

  verificationType?: string | null;

  verifiedat?: string | null;

  verifiedby?: string | null;

  source?: string;

  id?: string;

  preferredSkillName?: {
    en_US?: string;
    en_UK?: string;
  };

  parentskill?: {
    id?: string;

    preferredSkillName?: {
      en_US?: string;
      en_UK?: string;
    };

    parentskill?: any;

    depth?: string;

    relations?: any[];
  } | null;

  depth?: string;

  relations?: any[];
}

export interface SelectedUser {
  id?: string;
  employeeNumber?: string;

  name?: {
    fullName?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
  };

  email?: string;

  profileImageUrl?: string;

  supervisor?: string[];

  location?: {
    city?: string;
    region?: string;
    country?: string;
    locationName?: string;
    workingLocation?: string;
  };

  employment?: {
    bg?: string;
    du?: string;
    band?: string;
    role?: string;
    grade?: string;
    title?: string;
    clientName?: string;
    designation?: string;
    organization?: string;
    operatingUnit?: string;
    assignmentStatus?: string;
  };

  billing?: {
    billingBg?: string;
    billingRole?: string;
    billingRoleEndDate?: string;
    billingRoleStartDate?: string;
  };

  project?: {
    projectName?: string;
    projectNumber?: string;
    projectManager?: string;
    allocationEndDate?: string;
    allocationStartDate?: string;
  };

  enabled?: boolean;
}

export interface EndorsementSliceState {
  isEndorseModalOpen: boolean;
  selectedUser?: SelectedUser | null;
  selectedSkills?: SelectedSkill[];
  endorsementSkills?: any;
}

const initialState: EndorsementSliceState = {
  isEndorseModalOpen: false,
  selectedUser: null,
  selectedSkills: [],
  endorsementSkills: null
};

const EndorsementSlice = createSlice({
  name: "endorsementSlice",

  initialState,

  reducers: {
    setIsEndorseModalOpen(state, action: PayloadAction<boolean>) {
      state.isEndorseModalOpen = action.payload;
    },

    setSelectedUser(state, action: PayloadAction<SelectedUser | null>) {
      state.selectedUser = action.payload;
    },

    setSelectedSkills(state, action: PayloadAction<SelectedSkill[]>) {
      state.selectedSkills = action.payload;
    },
    setEndorsementSkills(state, action: PayloadAction<any | null>) {
      state.endorsementSkills = action.payload;
    },

    resetEndorsementState(state) {
      state.isEndorseModalOpen = false;
      state.selectedUser = null;
      state.selectedSkills = [];
    }
  }
});

export default EndorsementSlice;

export const EndorsementSliceActions = EndorsementSlice.actions;
